import type { LangString } from '@/graphql/generated';
import RUFlag from '@/assets/img/common/flags/RU.svg';
import UKFlag from '@/assets/img/common/flags/UK.svg';

export const languages = {
  RU: {
    icon: RUFlag,
  },
  EN: {
    icon: UKFlag,
  },
};

export const getLanguageIcon = (langCode: string) => languages[langCode as keyof typeof languages].icon;

export type MultilanguageValue = {
  langCode: string;
  value: string;
};

export const getDefaultMultilanguageValues = (): MultilanguageValue[] => [
  {
    langCode: 'RU',
    value: '',
  },
  {
    langCode: 'EN',
    value: '',
  },
];

export const getMultiLanguagesValues = (values: LangString[]): MultilanguageValue[] =>
  values.map((item) => ({
    langCode: item.langCode,
    value: item.value,
  }));
